import { AssetType, useAlmanacFileSubscription } from 'hooks/useAlmanacFileSubscription'
import { useFinderContext } from 'screens/Finder/FinderContext'

interface Props {
  file: {
    id: string
    type: string
  }
}

const AssetTypeFromFileType: Record<string, AssetType> = {
  folder: AssetType.Project,
  handbook: AssetType.Handbook,
  article: AssetType.Article,
  media_file: AssetType.MediaFile,
  design: AssetType.Design,
  Design: AssetType.Design,
}

export const FileSubscription = ({ file }: Props) => {
  const { refreshAfterExternalChange } = useFinderContext()
  useAlmanacFileSubscription({
    asset: { id: file.id, type: AssetTypeFromFileType[file.type] },
    onAttributesChange: refreshAfterExternalChange,
  })

  return null
}
